<template>
  <li>
    <div :class="isFolder ? this.ClassNames.FolderClass : ''">
      <div v-if="isFolder" @click="toggle">
        <span>{{ open ? "-" : "+" }} {{ model.name }}</span>
      </div>
      <ArchivePostItem :model="model" v-else />
      <ul v-show="open" v-if="isFolder" :class="ClassNames.ItemList">
        <tree-item
          class="item"
          v-for="model in model.children"
          :key="model.name"
          :model="model"
          :ClassNames="ClassNames"
          :class="'item ' + ClassNames.ItemClass"
        />
      </ul>
    </div>
  </li>
</template>

<script>
import ArchivePostItem from "./ArchivePostItem.vue";

export default {
  name: "TreeItem",
  props: {
    model: Object,
    ClassNames: Object,
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    isFolder() {
      return (
        this.model && this.model.children && this.model.children.length > 0
      );
    },
  },
  methods: {
    toggle() {
      if (this.isFolder) {
        this.open = !this.open;
      }
    },
  },
  components: {
    ArchivePostItem,
  },
};
</script>

<style lang="postcss">
.recent-posts {
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.4em;
  li {
    overflow: hidden;
    a {
      text-decoration: none;
      &:hover {
        opacity: 0.8;
      }
    }
  }

  .recent-title {
  }

  .recent-date {
  }

  .recent-info {
    margin-top: 5px;
    font-size: 13px;
    color: #888;
  }
}
</style>